<div class="row">
    <div class="col-md-6 mx-auto pt-3">
        <p>
            <ngb-alert [dismissible]="false" *ngIf="alert" [type]="alertType">
                {{alert}}
            </ngb-alert>
        </p>

        <div class="d-flex justify-content-center">
            <div style="width: 150px">
            </div>
        </div>

        <h3>
            <ng-container *ngIf="uuid||reset" i18n>Reset password</ng-container>
            <ng-container *ngIf="!uuid&&!reset" i18n>Login</ng-container>
        </h3>

        <p *ngIf="uuid||reset">--- forklaring / velkomst ---</p>

        <div *ngIf="uuid">
            <form (ngSubmit)="finishResetPassword()" #resetForm="ngForm" novalidate>
                <div class="form-group">
                    <label for="password" i18n>New password</label>
                    <input type="password" class="form-control" id="password"
                           [(ngModel)]="user.password" name="password"
                    >
                </div>
                <div class="form-group">
                    <label for="password" i18n>Repeat new password</label>
                    <input type="password" class="form-control" id="password_confirm"
                           [(ngModel)]="user.password_confirm" name="password"
                    >
                </div>

                <div class="d-flex justify-content-between">

                    <button type="submit" class="btn btn-success" [disabled]="!resetForm.form.valid || submitted">
                        <i class="fas fa-circle-notch fa-spin" *ngIf="submitted" style="margin-right: 0.5em"></i>
                        <ng-container i18n>Reset password</ng-container>
                    </button>
                    <a routerLink="/login" class="btn btn-light" i18n>Cancel</a>

                </div>
            </form>

        </div>
        <div *ngIf="!uuid">
            <form (ngSubmit)="onSubmit()" #loginForm="ngForm" novalidate>
                <div class="mb-3">
                    <label for="username" i18n>Username</label>
                    <input type="email" class="form-control" id="username" required
                           [(ngModel)]="user.username" name="username"
                    >
                </div>
                <div class="mb-3" *ngIf="!reset">
                    <label for="password" i18n>Password</label>
                    <input type="password" class="form-control" id="password"
                           [(ngModel)]="user.password" name="password"
                    >
                </div>

                <div class="mb-3 d-flex justify-content-between">

                    <button type="submit" class="btn btn-success" [disabled]="!loginForm.form.valid || submitted">
                        <i class="fas fa-circle-notch fa-spin" *ngIf="submitted" style="margin-right: 0.5em"></i>
                        <ng-container *ngIf="reset" i18n>Reset password</ng-container>
                        <ng-container *ngIf="!reset" i18n>Login</ng-container>
                    </button>

                    <button (click)="reset = !reset" *ngIf="reset" class="btn btn-light" i18n>Cancel</button>
                </div>
            </form>
            <div class="pt-3" *ngIf="!reset">
                <p>
                    <ng-container i18n>If you have forgotten your password</ng-container>&nbsp;<a
                        (click)="reset = !reset" href="javascript:">
                    <ng-container i18n>reset password</ng-container>
                </a></p>
            </div>
        </div>
    </div>
</div>
